// removed by extract-text-webpack-plugin
module.exports = {"aboutContents":"aboutContents__1LEk0","achievementsWrapper":"achievementsWrapper__s5iOU","tileContainer":"tileContainer__2u8cF","imageContainer":"imageContainer__2yOab","image":"image__3g-ZX","arrowSize":"arrowSize__1tktB","merchantSliderContainer":"merchantSliderContainer__2z362","customPagination":"customPagination__3n8xH","pagination":"pagination__2aE3Y"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/merchantsCarousel/style.css
// module id = 7UC6
// module chunks = 444